/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=a331c174&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a331c174&lang=less&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/1bf991ab-cd6c-4dc0-b58b-c0004fbfb0b5/workspace/zhongtaisdklistandotherh5_online/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a331c174"]])

export default __exports__